module.exports = __webpack_public_path__ + "static/media/contactSupport.00145eae.gif";